<template>
  <FreeBottomSheet :name="name">
    <template #header>
      <div class="p-4">
        <div
          class="bg-situational-lightgrey flex justify-center rounded-2xl px-7 py-4"
        >
          <img
            src="../../../assets/images/cashback-coin.webp"
            width="300"
            height="125"
            alt=""
          />
        </div>
      </div>
      <h5 class="text-text-neutral-primary px-4 pt-2 text-xl font-semibold">
        {{ t('cashbackBottomSheet.title') }}
      </h5>
    </template>
    <div class="text-text-neutral-primary px-4 pb-6 pt-2">
      <p class="pb-6 text-base">
        {{ t('cashbackBottomSheet.subTitle') }}
      </p>
      <div class="pb-6">
        <h5 class="pb-2 text-lg font-semibold">
          {{ t('cashbackBottomSheet.howWorks.title') }}
        </h5>
        <ol class="pl-1.5 text-base">
          <li>1. {{ t('cashbackBottomSheet.howWorks.first') }}</li>
          <li>2. {{ t('cashbackBottomSheet.howWorks.second') }}</li>
          <li>3. {{ t('cashbackBottomSheet.howWorks.third') }}</li>
        </ol>
      </div>
      <FreeButton
        type="button"
        class="green-main-button w-full text-lg font-semibold"
        @click="bottomSheet.hide(name)"
      >
        {{ t('cashbackBottomSheet.confirm') }}
      </FreeButton>
    </div>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeBottomSheet, FreeButton } from 'freedom-shared';
  import { controllerModel } from 'shared';

  const { name } = defineProps<{
    name: string;
  }>();

  const bottomSheet = controllerModel.useBottomSheet();

  const { t } = useI18n();
</script>

<i18n src="../config/locales.json"></i18n>
